import { useAsync } from '@src/hooks/core/core-hook-imports';
import SearchApiService from '@src/js/services/search-api-service';

/**
 * Queries search api for blog categories, and returns a React promise handler that contains a flat list of categories.
 *
 * @param search the searched term (if present)
 * @param immediate whether or not to run the search immediately (if false, you must manually call the
 * returned run function to run it)
 * @returns {*} useAsyncResponse containing {loading, error, response}
 */
const useBlogCategorySearch = ({ search, immediate = false }) => {
  const searchApiService = new SearchApiService();

  const getData = async () => {
    const results = await searchApiService.searchBlogCategories(search);
    // surface only row content and combine it into one array
    const flatResults = results.map(r => r.rows).flat();
    const uniqueList = [...new Set(flatResults)];
    uniqueList.sort((a, b) => {
      if (!a['field_category']) {
        return 1;
      } else if(!b['field_category']) {
        return -1;
      } else {
        return a['field_category'].localeCompare(b['field_category'])
      }
    });
    return uniqueList;
  }

  return useAsync(getData, immediate);
};

export default useBlogCategorySearch;
